import { render, staticRenderFns } from "./ViewControlPositionsOnDrawing.vue?vue&type=template&id=0517da4d"
import script from "./ViewControlPositionsOnDrawing.vue?vue&type=script&lang=js"
export * from "./ViewControlPositionsOnDrawing.vue?vue&type=script&lang=js"
import style0 from "./ViewControlPositionsOnDrawing.vue?vue&type=style&index=0&id=0517da4d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports